/**
 * @file   src\utils\constants.ts
 * @brief  This file is responsible define constants.
 * @date   June, 2024
 * @author ZCO Engineer
 * @copyright (c) 2024, ZCO
 */


export const STATUS_200 = 200;
export const STATUS_401 = 401;
export const STATUS_498 = 498;
export const STATUS_403 = 403;
export const STATUS_500 = 500;
export const API_TIMEOUT = 30000;
export const API_MAXCONTENTLENGTH = 1000;
export const API_REFRESH_TOKEN_ERROR = 1003;
export const SELF_SERVE_BAY_BUSY_ERROR=1035;
export const SELF_SERVE_BAY_OUTOFSERVICE_ERROR = 1036;
export const SIGNUP_FOR_FAMILYCODE_ERROR = 1039;
export const API_REDIRECTS = 5;
export const REFERRAL_LENGTH = 5;
export const PROMO_LENGTH = 4;
export const MAX_LENGTH = 15;
export const NAME_LENGTH = 50;
export const SUBJECT_MAX_LENGTH = 100;
export const MESSAGE_MAX_LENGTH = 500;
export const CARD_NUMBER_MAX_LENGTH = 19;
export const CARD_Expiry__MAX_LENGTH = 5;
export const CARD_CVV__MAX_LENGTH = 3;
export const PROFILE_NAME_MAX_LENGTH = 50;
export const EMAIL_MAX_LENGTH = 50;
export const PHONE_MAX_LENGTH = 14;
export const EMAIL_REGEX = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
export const PHONE_REGEX = /^\(\d{3}\) \d{3}-\d{4}$/;
export const BAY_AVAILABLE = 1;
export const BAY_BUSY = 2;
export const BAY_OUT_OF_SERVICE = 3;
export const BAY_QUEUE = 4;
export const YEAR_LIMIT = 4;
export const MONTH_LIMIT = 2;